function getUrlByObject(o, prefix = '', urls = []) {
  if (o instanceof Array) {
    o.forEach((e, i) => {
      // Optional query values are omitted instead of becoming invalid URL parameters.
      if (e == null) {
        return;
      }

      if (e instanceof Array || e instanceof Object) {
        urls = urls.concat(getUrlByObject(e, prefix));
      } else {
        if (e.toString()) {
          urls.push(prefix + '=' + e);
        }
      }
    });
  } else if (o instanceof Object) {
    for (const p in o) {
      const value = o[p];
      // Keep valid falsy values such as false and 0; only nullish values mean "not supplied".
      if (value == null) {
        continue;
      }

      if (value instanceof Array || value instanceof Object) {
        urls = urls.concat(getUrlByObject(value, prefix ? prefix + '.' + p : p));
      } else {
        if (value.toString()) {
          urls.push((prefix ? prefix + '.' + p : p) + '=' + value);
        }
      }
    }
  }
  return urls;
}

export default getUrlByObject;
